export const RU = "RU";
export const EN = "EN";
export const AM = "AM";